import { isRunningAsTWA } from "../../utils/pwaTwa/detectionHelper";

export function adtraceTwaProvider() {
  // Check if app is running as TWA
  const isTWA = isRunningAsTWA();
  if (!isTWA) return;

  // Extract gps_ad_id from the query params
  const urlParams = new URLSearchParams(window.location.search);
  const gpsAdId = urlParams.get("gps_ad_id");

  // If gps_ad_id is found, store it in localStorage
  if (gpsAdId) {
    localStorage.setItem("gps_ad_id", gpsAdId);
  }
}
